import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'; 
import { getAllHome } from '../../../actions/home';
import { adminCatgeoryAddAction } from '../../../actions/Admin/Category';
import NavMenu from '../sidebar/navBar';
import { notification } from 'antd';
import SideMenu from '../sidebar/SidebarCustom';
import './../App.css';

class AdminAddCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            fieldsList: [],
            code: '',
            fieldSelct: '',
            formData: {},
        }
    }

    componentWillMount() {
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        
        this.props.getAllHome(reqObj);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.fields && nextProps.fields.length > 0) {
            this.setState({
                fieldsList: nextProps.fields
            })
        } 

        if (nextProps && nextProps.category && nextProps.category.statusCode===200) {
            notification.success({
                message: nextProps.category.msg,
                className:'successNotification',
                duration: 3
            });
            this.setState({
                formData: {}
            })
        }
        if (nextProps && nextProps.category && nextProps.category.statusCode===500) {
            notification.error({
                message: nextProps.category.msg,
                className:'errorNotification',
                duration: 3
            });
            
        }
    }

    toggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }
      //console.log("serData.userType", userData.userType);
    inputchange=(e)=>{
        e.preventDefault();
        const {formData} = this.state
        formData[e.target.name]=e.target.value;
        this.setState({
            formData:formData
        })

    }

    addCategory=()=>{
        const {formData} =this.state;

        if(formData!==undefined&&formData.name!==""){
            this.props.adminCatgeoryAddAction(this.state.formData)
        }else{
            alert("Please define the category name")
        }
    }


    render() {
        const { formData } = this.state; 
        return (
            <div className="wrapper">
                <SideMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                <div id="content">
                <NavMenu toggle={this.toggle} isOpen={this.state.isOpen}/>
                    <div className="row">
                        <div className="col-md-8">
                           
                                <div className="col-md-6">
                                    <label>Category Name</label>
                                    <input type="text" id="categoryName" name="name" className="input-field-control"  onChange={this.inputchange} placeholder="Category Name" value={formData.name} required/>
                                </div>
                                <div className="col-md-6">
                                    <label>Description</label>
                                    <textarea rows="3" id="descriptionCateg" name="description"  onChange={this.inputchange} className="" value={formData.description} placeholder="Description"></textarea>
                                </div>
                                <div className="col-md-6">
                                    <button type="submit" className="btn" onClick={this.addCategory}>Submit</button>
                                </div>
                            
                        </div>
                    </div>
                </div>
            </div> 
        );
    }
}

function mapStateToProps(state) {
    return {
        fields: state.home.response.data,
        category: state.Category.response
    };
}

export default withRouter(connect(mapStateToProps, {
    getAllHome,
    adminCatgeoryAddAction,
})(AdminAddCategory));


// WEBPACK FOOTER //
// ./src/components/Admin/Category/CategoryAdd.js